const typeTagNames = {
    // Primary Types
    "general-emergent": "Emergent",
    "cancelled": "Cancelled/No Pt",
    "refusal": "Refusal", 
    "non-acute": "Non-Acute/Other",
    "non-emergent": "Non-Emergent",
    "unknown": "Unknown",

    // Secondary Types
    "stroke": "Stroke",
    "arrest": "Arrest", 
    "stemi": "STEMI",
    "trauma": "Trauma",
    "respiratory": "Resp",
    "seizure": "Seizure",
    "syncope": "Syncope",
    "tbi": "TBI",
    "hypoglycemia": "LBG",
    "asthma": "Asthma",

    // Tertiary Types
    "airway": "Airway",
    "cardiac": "Cardiac",
    "narcotics": "Narcs",
    "pediatrics": "Ped",
    "high-risk-refusal": "HRR",

    // Auxiliary Types
    "ground-transport": "Ground",
    "critical": "Critical",
    "stable": "Stable",
    "ecg": "ECG",

    // Other
    "suggestions": "💬" // 🗩
};

const primaryTypeTagNames = [
    "general-emergent",
    "cancelled",
    "refusal",
    "non-acute",
    "non-emergent",
    "unknown"
];

const secondaryTypeTagNames = [
    "stroke",
    "arrest",
    "stemi",
    "trauma",
    "respiratory",
    "seizure",
    "syncope",
    "tbi",
    "hypoglycemia",
    "asthma"
];

const tertiaryTypeTagNames = [
    "airway",
    "cardiac",
    "narcotics",
    "pediatrics",
    "high-risk-refusal"
];

const auxiliaryTypeTagNames = [
    "ground-transport",
    "critical",
    "stable",
    "ecg"
];

const otherTagNames = [
    "suggestions"
];

const attributeTagNames = {
    "check": "Check",
    "measure": "Measure",
    "quant-measure": "Quantitative Measure",
    "schematron": "Schematron"
};

export { typeTagNames, attributeTagNames, primaryTypeTagNames, secondaryTypeTagNames, tertiaryTypeTagNames, auxiliaryTypeTagNames, otherTagNames }; 